import { React, useState, useEffect } from 'react';
import './Intromodule.scss';

function IntroModule(props) {

  const [moduleContent, updateModuleContent] = useState({
    moduleName: '',
    content: '',
    moduleIdx: '',
  });

  useEffect(() => {
    if (props && props.moduleContent) {
      if (props.moduleContent.moduleName !== 'About WeTV') {
        const filterImg = props.moduleContent.content ? props.moduleContent.content.replace(/<img.*?(?:>|\/>)/gi, '') : '';
        props.moduleContent.content = filterImg;
      }
      updateModuleContent({
        moduleName: props.moduleContent.moduleName,
        moduleIdx: props.moduleContent.moduleIdx,
        content: props.moduleContent.content,
      })
    }
  }, [props]);

  useEffect(() => {
    if (moduleContent.moduleIdx) {
      const moduleContentDoc = document.querySelector(`.${moduleContent.moduleIdx}`);
      moduleContentDoc.innerHTML = moduleContent.content;
    }
  }, [moduleContent.content, moduleContent.moduleIdx]);

  return (
    <div className="introModule">
      <div className="moduleContent">
        <h4
          className="moduleTitle"
        >
          {moduleContent.moduleName}
        </h4>
        <div className={`${moduleContent.moduleIdx}`}>
        </div>
      </div>
      <></>
    </div>
  );
}

export default IntroModule;
